import { createSelector } from 'reselect'
import { domain } from './constants'
import { hget } from '../../modules/hash'

export const isSocketConnected = createSelector(
  hget(domain, 'isConnected'),
  Boolean
)



// WEBPACK FOOTER //
// ./src/services/connection/selectors.js